import React from 'react';
import { useSelector } from 'react-redux';
import { AnimatePresence } from 'framer-motion';

import { LoadingSpinner } from '@components/LoadingSpinner';

export const AnimateWhileLoading = ({ children }) => {
  const { isLoading } = useSelector(({ appState }) => appState);

  return (
    <AnimatePresence initial={false}>
      {isLoading ? <LoadingSpinner /> : children}
    </AnimatePresence>
  );
};
